export default __webpack_public_path__ + "static/media/two.50214409.jpeg";